import 'globals';

(function (window, document, $) {
    // Change the styling of the outermost class .columns when clicking on select-selected in the form, otherwise the dropdown is not completely visible.
    let selectField = document.querySelectorAll('.select-selected');
    for (let i = 0; i < selectField.length; i++) {
        const element = selectField.item(i);
        element.addEventListener('click', function () {
            if (element.classList.contains('select-arrow-active')) {
                // Change styling
                $(element).closest('.columns').css({
                    'position': 'static',
                    'overflow': 'visible'
                });
            } else {
                // Remove styling
                $(element).closest('.columns').removeAttr('style');
            }
        });
    }

    document.addEventListener('click', function () {
        // Remove styling when clicked anywhere else on the page
        $('form').closest('.columns').removeAttr('style');
    });
})(window, document, jQuery);
